/** @jsx jsx */
import { Component } from 'react'
import { connect } from 'react-redux'
import { jsx, css } from '@emotion/core'
import { map, size } from 'lodash'
import { withRouter } from 'react-router'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import { default_theme as theme } from '../../emotion/theme'

class AdminTableHeader extends Component {

    render() {
        const { title, children, custom_height, custom_background } = this.props
        return (
            <Container fluid>
              <Row>
                <Col className="col-auto mr-auto">
                  <h1>{title}</h1>
                </Col>
                <Col className="col-auto">
                  <Row>
                    { !children.length && <Col>{children}</Col> }
                    { children.length > 1 && map(children, (child, index) => <Col key={index} >{child}</Col>)}
                  </Row>
                </Col>
              </Row>
            </Container>
        )
    }
}

function mapStateToProps(state, props) {
    const { children } = props
    return {
        children
    }
}
export default withRouter(connect(mapStateToProps)(AdminTableHeader))

const header = css`
display: flex;
flex-direction: row;
justify-content: space-between;
background-color: ${theme.colors.primary};
align-items: center;
height: 70px;
width: 100%;
border-top-left-radius: 10px;
border-top-right-radius: 10px;
padding-right: 15px;
padding-left: 15px;
`
